//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Tag } from 'vant'
import { set } from '@/utils/util'
import {
  cloneDeep,
  dig,
  remove,
} from '@/utils/lodash'

export default {
  components: { Tag },

  props: {
    value: {
      type: [
        Array,
        String,
        Number,
      ],
      default: '',
    },

    dataPath: {
      type: String,
      default: 'data',
    },

    width: {
      type: [
        String,
        Number,
      ],
      default: 56,
    },

    closeable: {
      type: Boolean,
      default: false,
    },

    multi: {
      type: Boolean,
      default: true,
    },

    params: {
      type: Object,
      default: () => ({}),
    },

    list: {
      type: Array,
      default: () => ([
        {
          wid: 123,
          name: '啥对啊时代i大海',
        },
        {
          wid: 13,
          name: '回复对方活动经费',
        },
      ]),
    },

    valueName: {
      type: String,
      default: 'key',
    },

    apiMethod: { type: Function },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

    labelFormat: {
      type: String,
      default: '{name}',
    },

    dataHook: { type: Function },
  },

  data () {
    return {
      selectedTag: [],
      innerList: [],
    }
  },

  computed: {},

  watch: {
    value: {
      handler (val) {
        this.selectedTag = this.multi ? (cloneDeep(val) || []) : (cloneDeep(val) || '')
      },
      deep: true,
      immediate: true,
    },
  },

  created () {
    this.doQuery(this.value)
  },

  methods: {
    async doQuery (val) {
      if (this.apiMethod) {
        const result = await this.apiMethod({ ...this.params }, this.methodConfig, this.postMethod)

        const data = dig(result, this.dataPath) || []

        if (this.dataHook) {
          this.innerList = this.dataHook(data || [])
        } else {
          this.innerList = data || []
        }
      } else {
        this.list.forEach((el) => {
          const flag = val instanceof Array ? val.indexOf(el[this.valueName]) >= 0 : val === el[this.valueName]

          if (flag) {
            set(el, 'active', true)
          } else {
            set(el, 'active', false)
          }
        })

        this.innerList = cloneDeep(this.list)
      }
    },

    closeTag (tag) {
      this.removeTagFromSelected(tag)
      this.$emit('input', this.selectedTag)
      this.$set(tag, 'closed', true)
      this.$emit('close', tag)
    },

    removeTagFromSelected (tag) {
      remove(this.selectedTag, (el) => {
        return tag[this.valueName] === el
      })
    },

    filterActiveFlag (tag) {
      return this.multi ? this.selectedTag.indexOf(tag[this.valueName]) >= 0 : this.selectedTag === tag[this.valueName]
    },

    selectTag (tag) {
      this.$emit('click', tag)
      if (!this.filterActiveFlag(tag)) {
        this.selectedTag = this.multi ? this.selectedTag.concat([tag[this.valueName]]) : tag[this.valueName]
      } else {
        this.multi ? this.removeTagFromSelected(tag) : this.selectedTag = ''
      }

      this.$emit('input', this.selectedTag)
      this.$emit('on-select', tag)
    },
  },
}
